import CancelIcon from '@mui/icons-material/Cancel';
import { IconButton, TableCell, TableRow, Theme, Tooltip, useTheme } from '@mui/material';
import moment from 'moment';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import useMessageUsersMassDm from '../../../../hooks/useMessageUsersMassDm';
import { OnlyFansWSChatQueueUpdateMessage } from '../../../../hooks/useSubscriberMassDmQueue';
import NA from '../../../common/NA';

const MessageUsersAutoMassDmQueueName = ({ massDmId }: { massDmId: number }) => {
    const { data: massDm, isLoading: isMassDmLoading } = useMessageUsersMassDm(massDmId);

    if (isMassDmLoading) {
        return <span>Loading...</span>;
    }

    return <span>{massDm?.schedule?.name || massDm?.name || 'Untitled'}</span>;
};

interface Props {
    queueItem: OnlyFansWSChatQueueUpdateMessage.ChatQueueUpdate;
    handleUnsendMassDm: (massDmId: number) => void;
}

const MessageUsersAutoMassDmQueueListRow = (props: Props) => {
    const { queueItem, handleUnsendMassDm } = props;
    const theme: Theme = useTheme();

    // const { data: queueDetails, isLoading: isQueueDetailsLoading } = useSubscriberMassDmQueueDetails(true, queueItem.id);

    const calculatePercentage = (pending: number, total: number): number => {
        return ((total - pending) / total) * 100;
    };

    return (
        <TableRow>
            <TableCell
                align="center"
                sx={{
                    fontFamily: 'monospace',
                }}
            >
                <Tooltip
                    title={
                        <span>
                            <strong>
                                {calculatePercentage(queueItem.pending, queueItem.total).toLocaleString(undefined, {
                                    maximumFractionDigits: 2,
                                    maximumSignificantDigits: 2,
                                })}
                                % Complete
                            </strong>
                            <br />
                            ID: {queueItem.id.toString()}
                        </span>
                    }
                >
                    <span>
                        <CircularProgressbar
                            value={calculatePercentage(queueItem.pending, queueItem.total)}
                            strokeWidth={50}
                            styles={buildStyles({
                                pathColor: theme.palette.primary.main,
                                backgroundColor: theme.palette.grey.A100,
                                strokeLinecap: 'butt',
                            })}
                        />
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell
                sx={{
                    fontFamily: 'monospace',
                }}
            >
                {moment(queueItem.date).format('L LT')}
            </TableCell>
            <TableCell>
                <MessageUsersAutoMassDmQueueName massDmId={queueItem.id} />
            </TableCell>
            <TableCell
                align="right"
                sx={{
                    fontFamily: 'monospace',
                }}
            >
                {queueItem.total - queueItem.pending !== -1 ? (queueItem.total - queueItem.pending).toLocaleString() : <NA />}
            </TableCell>
            <TableCell
                align="right"
                sx={{
                    fontFamily: 'monospace',
                }}
            >
                {queueItem.total !== -1 ? queueItem.total.toLocaleString() : <NA />}
            </TableCell>
            <TableCell align="center">
                <IconButton
                    color="error"
                    onClick={() => {
                        handleUnsendMassDm(queueItem.id);
                    }}
                >
                    <CancelIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default MessageUsersAutoMassDmQueueListRow;
